/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tabsources1Inputs */

const en_tabsources1 = /** @type {(inputs: Tabsources1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources`)
};

const pt_tabsources1 = /** @type {(inputs: Tabsources1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fontes`)
};

/**
* | output |
* | --- |
* | "Sources" |
*
* @param {Tabsources1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const tabsources1 = /** @type {((inputs?: Tabsources1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tabsources1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tabsources1(inputs)
	return pt_tabsources1(inputs)
});
export { tabsources1 as "tabSources" }